import React, { useContext, useEffect, useState } from 'react';
import {
  HCPCSGlobalContext,
  SET_HCPCS_CODE_MAP,
} from '@mummssoftware/global-context/HCPCSGlobalContext';
import { getHCPCScode } from '@mummssoftware/utils/hcpcsUtils';
import { HCPCSTitle } from './HCPCSWrapper';

type HCPCSCodeProps = {
  hcpcsChoice: mumms.HCPCSMenuItem;
};

export const HCPCSCode = ({ hcpcsChoice }: HCPCSCodeProps) => {
  const { hcpcsDuration, dispatchHCPCS } = useContext(HCPCSGlobalContext);
  const [code, setCode] = useState<{
    uiCode: string;
    hcpcsCode: string[];
  } | null>(null);

  useEffect(() => {
    if (hcpcsDuration) {
      if (hcpcsChoice.rules && Object.keys(hcpcsChoice.rules).length) {
        const hcpcsRules = hcpcsChoice.rules;
        const codeMap = getHCPCScode(
          hcpcsDuration[hcpcsChoice.key],
          hcpcsRules,
          hcpcsChoice,
        );
        setCode(codeMap);
        codeMap &&
          dispatchHCPCS({
            type: SET_HCPCS_CODE_MAP,
            payload: { key: hcpcsChoice.key, codes: codeMap.hcpcsCode },
          });
      }
    }
  }, [hcpcsDuration && hcpcsDuration[hcpcsChoice.key]]);

  return code && code.uiCode ? (
    <div id="hcpcs-code">
      <HCPCSTitle>{code.uiCode}</HCPCSTitle>
    </div>
  ) : (
    <></>
  );
};
